
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqfeHh1jJIdNYGxH_Wsv0f_4571Z4nim_PSP2ebyMRTg_zcMeta } from "/codebuild/output/src2789498530/src/src/pages/faq.vue?macro=true";
import { default as menuTYl2ss6P_45C01abflWCvO8fEGgT9Xwd0gL_45rVF5_45J1CYMeta } from "/codebuild/output/src2789498530/src/src/pages/menu.vue?macro=true";
import { default as indexwEIscg9U9Y0stsdNjeE9kevV2c3_8MVvYGjXz2zIMTMMeta } from "/codebuild/output/src2789498530/src/src/pages/index.vue?macro=true";
import { default as contactDeodt4dQppbxy9e5UVv6IKtWUi_G0vQJPk_45P3H7sWJ0Meta } from "/codebuild/output/src2789498530/src/src/pages/contact.vue?macro=true";
import { default as tutorialkWswn6mSX7tFujI1jDmkRLl1N4oeOwTG2271wxWcCRQMeta } from "/codebuild/output/src2789498530/src/src/pages/tutorial.vue?macro=true";
import { default as agreementIpKopYVJa7010DC6ZFHgyEYJU4cLT6WwrkX_Doq4wzEMeta } from "/codebuild/output/src2789498530/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass9JI6JX4jLc47HMm6nD1VqO6kyP93NNiCgQsb04EH5xUMeta } from "/codebuild/output/src2789498530/src/src/pages/about-pass.vue?macro=true";
import { default as indexYJxG493epfEs1gxCe2NStZDimo59eTcGcIctFFOZ4TEMeta } from "/codebuild/output/src2789498530/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93NaNWcFcJANlJzTKJzSjD7TjSSppGIm9UXpSs2_45gwzUoMeta } from "/codebuild/output/src2789498530/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancepES08q7CA6kBPoWz14yiTdOchkZJM_45XysJ07kejkCX0Meta } from "/codebuild/output/src2789498530/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93Lp5wLXIRoPd2Akmmnv416DJoc7rrLf7_45_45RQJd7rTP6QMeta } from "/codebuild/output/src2789498530/src/src/pages/notice/[id].vue?macro=true";
import { default as indexZtoq29vIsN4tdKpVw_wbLz7vCG8kRHO6XPYkXZUjokMMeta } from "/codebuild/output/src2789498530/src/src/pages/coupon/index.vue?macro=true";
import { default as indexQbeR9rghId6Njf9GqyRJgDhsQcgZPrlK82c290mmQBYMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/index.vue?macro=true";
import { default as indexHtfZb2HRHRw2307f3xN70UFzuBVbaNpL9R7CzHMK8McMeta } from "/codebuild/output/src2789498530/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93LAdnx1PNLom34Kssb0zxb1GKXqNUayGlwU12cKX6a2wMeta } from "/codebuild/output/src2789498530/src/src/pages/parking/[id].vue?macro=true";
import { default as indexlwqoYhu3BzeBPq_jHRzeMrW1ifPAe_45WMtZfzLXI_Y3QMeta } from "/codebuild/output/src2789498530/src/src/pages/history/index.vue?macro=true";
import { default as indexPDQDWAOMjbQGIdEDWIAEou9JFAu1odQNm5GskpE8RjwMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/index.vue?macro=true";
import { default as indexkZhlLRCihvu9wvffq8yFQabLWtA3yIkZ2_Wsn4_CUC4Meta } from "/codebuild/output/src2789498530/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexx1H40T_Vzgi3HGeAsJKUTrlodIUSvuJ0XUoRK30JIaUMeta } from "/codebuild/output/src2789498530/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviGDzQiVmalBu1mK242rYkeVGrAvRYFghs_45kqJMCwKkqIMeta } from "/codebuild/output/src2789498530/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editH8ENbkjBWn_45zh_ZzwhXrdZp_vlsgzc7WN09Xh0ITmtEMeta } from "/codebuild/output/src2789498530/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementGxF1UYhOl1Pv2wEGn9_C389Gp0iSaJK2JGWvHG_45QFGwMeta } from "/codebuild/output/src2789498530/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexMhbiVH0vsSE32FqgPb7UDTda76x5JJA0wn0Uf8V1zyAMeta } from "/codebuild/output/src2789498530/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d6y0OyIxkLNYsXsIVqr0nYdkdC7DktfePmztu2KB3u7cMeta } from "/codebuild/output/src2789498530/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmKJQvd8HUg8fFdCEK7VuwrqmgaQuT5aL58YDphCTFwk0Meta } from "/codebuild/output/src2789498530/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexVQ9KT0a51Wsjp1jbFPMvOgiTbkTgU7loQlFjSy1y1T0Meta } from "/codebuild/output/src2789498530/src/src/pages/card/create/index.vue?macro=true";
import { default as indexz9g7DJE8MzMw_rg0m4m3RJ5BfufIdhkiYmRKqVjzi5QMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm2NO_VN4w2clKhm9mrzen1KaBh3qyrtcXMcE11m1d_45isMeta } from "/codebuild/output/src2789498530/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmNSYwhymCAwqbs8Q1t_45PAfCPsfbwA5u98jo7lw7U0KPMMeta } from "/codebuild/output/src2789498530/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete7_454Cn5RN9qV0bk2sGVZLpTNpNHg83tkYV46nxRHX4RoMeta } from "/codebuild/output/src2789498530/src/src/pages/membership/complete.vue?macro=true";
import { default as registerjjtsaVxevPYlnunkqB1UOSWPD8vDez2Q_45aMlt3eoSHwMeta } from "/codebuild/output/src2789498530/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93SUvyLVRTufVDpnnb9HxKYIAMZiZj_45PdNU85Cu74WHTgMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmT1zqLk_45x9vuadGlCsfJ9dbs9cNpn7XMEs_45pBpeUYsosMeta } from "/codebuild/output/src2789498530/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93vf7tM3hGnPxMTPTLdDM2QF_8leG7TNaG4XmnXpO_45iawMeta } from "/codebuild/output/src2789498530/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexNcw2s2di03zGsUw9u5T64DYdhhcorjmFeeXZsfUJivwMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeUp3rt1JAdBIrskIutbkPKJOEgVx7EWya65B6qtxKyOQMeta } from "/codebuild/output/src2789498530/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeBIZoHtgrgyQl3ZdcdJOfUu2GUqm4_45X70JH7EKD1nq3sMeta } from "/codebuild/output/src2789498530/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeCtvN6d5f594DudtGFigSj7tuGd1HCmDM6maO4XICW2kMeta } from "/codebuild/output/src2789498530/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerjrrW9RbKEVNiS0gK_awre1shbEDnblRPMkRzQ_nbCA4Meta } from "/codebuild/output/src2789498530/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete4LTcfRqXEB3y_bm8Dyaub56zKRouFWdjaO_k7RzAe2AMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexX6pqtJ2Ttvnivg6QfIDUqFQgVg8Jy_45ArN_45dkcxf1rnYMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmAMsCNnzooQWK1cGq4L8huET5pPyVBd1c5fYwflgyN6MMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completejNBFu9TpeD0_zzkU3VZ0Ej5A4km5y07XDSdJVvFLgSAMeta } from "/codebuild/output/src2789498530/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index7IgDxS_45oZVwukDymRW9I0BhJ3h8wR2dncroJziFWUPoMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93crEbqOKQC80I6D4X42ef3IsDXvNsnacVCKToB8mP7SkMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completev46q6GQPUL8Q7DTEaeoUP90nC6vSGE4Dy6PcpdF85Z8Meta } from "/codebuild/output/src2789498530/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasRLcFt244UwMX8Y_45oOvkjE1wNn_45uzvEMKGa3aw_45E2GkkMeta } from "/codebuild/output/src2789498530/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleY7VHVsvczXaEM1rZlUnM7sszgwkonhXZWGWER14L4_45AMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailT6sYmVvczjXkeZ25MPvm4ZibWGYoziba6829si8rw1gMeta } from "/codebuild/output/src2789498530/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm74c5SjYaZvWonpjc9rc34ukiQmDaL1Knt_45C5LaOH_H8Meta } from "/codebuild/output/src2789498530/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentz4iy7ACQ_45Smfv1ldLI6mD0XLkMGsibx_bJDpxTEmGEYMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmQCXJ_45Nnf97cll99dU0frt3WD_uG46XOCSm0aQjxyI1YMeta } from "/codebuild/output/src2789498530/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate8F38VNDb5HyglWq7qj_458Qhn_45gbqDIJnafCKxrgEKWmYMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completenTsHpJwui6QXbD7zvmPhfd9_QiC9_DkDdIlBppxPNmAMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codecI7QUg_lqi1jC4lYZWq_BCer_m0sJDNrUtI9j4TPhb8Meta } from "/codebuild/output/src2789498530/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordluu9Ln0d5JGm1lQF50FoaSkJqe01AJmx42FhELYkTxEMeta } from "/codebuild/output/src2789498530/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasJHxDFsk7NoOO2dhGLeiD_xFak5JcwfmOfRBcuyuqQzkMeta } from "/codebuild/output/src2789498530/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerLOct0tXLkFaS0nKYWEuAujQfE4AhWNtvFFi1Y7X9hTQMeta } from "/codebuild/output/src2789498530/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeN0yncALI7CcsZrdfFn_457HNa_VW78Q82mLpiESEYYpbwMeta } from "/codebuild/output/src2789498530/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index9CGxe4Httu33N4a6HjXamieTiDlbiI5gFOeDPOk2_45fQMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexNxJVqZbTnnNxVtthLDgcFM6lgDz_45rMhdQVYZypkShb0Meta } from "/codebuild/output/src2789498530/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexsbhqHQEB9J5x1NjD50OE_45uyGmpN7TAuq_QFwyLv6gAQMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index02YdLMWEabqrQHGn4sGXFnzkcIGYnLvP1vnVsxiyB9kMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateyKAtCbdarzhtuLb008Ir1bdWX1BxosfLZOXiIsso1XkMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completebIAyAtzemmw9Gm2QawgRNcrBoc_45kxoMMzlEK6GZgtjIMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmx_45EqRq1WAhaQchfkcF0dLb6fes1Ud5ebQQ1_AgDl7igMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexfZH_AbINHjQIV4kiykBRHFmuq4yeSPWEeH07PicDRu0Meta } from "/codebuild/output/src2789498530/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeGprJpVNtLMnqi8Dfktn9lIaCK_45AuJ66eBopEFt_BMD4Meta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateZcyBIScM7E3C70pBqZ_45bRM_VmDJ2Yz0GrI0ECII6o_45cMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexyKvTWQHUEZxnsRcnsEpQj8h4ydT9Y1c2gK2pnEjqDHwMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexfSbC57OkwxgGu8T6apWbcsFSnI1qJuzUA461LxXbNtQMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete4_vcaG1g4EDzeS_DwnRV1_xynS5fFWnVpOaI6jF6FzoMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexxx36_45LgStDOfsAyQRiOLzuHbP_leagWais34VFjO1cMMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeMolcaRP_450m1p1SPtwYcFsQlAwiEJG4T1PEVKh7B1deoMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index_ZUKR1pUeRXRic5y4ydw8RCLPcpQy9ZQ_45VMXBrH9AJoMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexH5vC1JbBsxo2UtLfFi_45h_Szt4K2EZU8OGfPkZj7YmL4Meta } from "/codebuild/output/src2789498530/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexpEBtc99Bp3FAZluoESLlRcYQO9Yu14gGvZv5KeOkBVYMeta } from "/codebuild/output/src2789498530/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateIBEoEB8DlMf6qfK3WaFuv6fU5lO6q1l_45uuAK9UrZvT0Meta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmDsj6r9nPdTKCTJ6m0ipmoBevz2X0BZRs9tu00fi5_45UcMeta } from "/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuTYl2ss6P_45C01abflWCvO8fEGgT9Xwd0gL_45rVF5_45J1CYMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexwEIscg9U9Y0stsdNjeE9kevV2c3_8MVvYGjXz2zIMTMMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexZtoq29vIsN4tdKpVw_wbLz7vCG8kRHO6XPYkXZUjokMMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexlwqoYhu3BzeBPq_jHRzeMrW1ifPAe_45WMtZfzLXI_Y3QMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexkZhlLRCihvu9wvffq8yFQabLWtA3yIkZ2_Wsn4_CUC4Meta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexx1H40T_Vzgi3HGeAsJKUTrlodIUSvuJ0XUoRK30JIaUMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexVQ9KT0a51Wsjp1jbFPMvOgiTbkTgU7loQlFjSy1y1T0Meta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm2NO_VN4w2clKhm9mrzen1KaBh3qyrtcXMcE11m1d_45isMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmNSYwhymCAwqbs8Q1t_45PAfCPsfbwA5u98jo7lw7U0KPMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete7_454Cn5RN9qV0bk2sGVZLpTNpNHg83tkYV46nxRHX4RoMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerjjtsaVxevPYlnunkqB1UOSWPD8vDez2Q_45aMlt3eoSHwMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmT1zqLk_45x9vuadGlCsfJ9dbs9cNpn7XMEs_45pBpeUYsosMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeUp3rt1JAdBIrskIutbkPKJOEgVx7EWya65B6qtxKyOQMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeBIZoHtgrgyQl3ZdcdJOfUu2GUqm4_45X70JH7EKD1nq3sMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeCtvN6d5f594DudtGFigSj7tuGd1HCmDM6maO4XICW2kMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerjrrW9RbKEVNiS0gK_awre1shbEDnblRPMkRzQ_nbCA4Meta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmAMsCNnzooQWK1cGq4L8huET5pPyVBd1c5fYwflgyN6MMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completejNBFu9TpeD0_zzkU3VZ0Ej5A4km5y07XDSdJVvFLgSAMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index7IgDxS_45oZVwukDymRW9I0BhJ3h8wR2dncroJziFWUPoMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completev46q6GQPUL8Q7DTEaeoUP90nC6vSGE4Dy6PcpdF85Z8Meta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleY7VHVsvczXaEM1rZlUnM7sszgwkonhXZWGWER14L4_45AMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailT6sYmVvczjXkeZ25MPvm4ZibWGYoziba6829si8rw1gMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm74c5SjYaZvWonpjc9rc34ukiQmDaL1Knt_45C5LaOH_H8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentz4iy7ACQ_45Smfv1ldLI6mD0XLkMGsibx_bJDpxTEmGEYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmQCXJ_45Nnf97cll99dU0frt3WD_uG46XOCSm0aQjxyI1YMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completenTsHpJwui6QXbD7zvmPhfd9_QiC9_DkDdIlBppxPNmAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codecI7QUg_lqi1jC4lYZWq_BCer_m0sJDNrUtI9j4TPhb8Meta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordluu9Ln0d5JGm1lQF50FoaSkJqe01AJmx42FhELYkTxEMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerLOct0tXLkFaS0nKYWEuAujQfE4AhWNtvFFi1Y7X9hTQMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeN0yncALI7CcsZrdfFn_457HNa_VW78Q82mLpiESEYYpbwMeta || {},
    component: () => import("/codebuild/output/src2789498530/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2789498530/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]